<script lang="ts">
    import NauiInput from "../lib/naui/atoms/NauiInput.svelte";
    import NauiButton from "../lib/naui/atoms/NauiButton.svelte";
    import { onMount } from "svelte";
    import NauiDateRange from "../lib/naui/atoms/NauiDateRange.svelte";
    import AuditoriaItem from "./components/AuditoriaItemConfirmar.svelte";
    import NauiSelect from "../lib/naui/atoms/NauiSelect.svelte";
    import Dialog, { Actions, Content, Title } from "@smui/dialog";
    import { TableExport } from "tableexport";
    import NauiCheckbox from "../lib/naui/atoms/NauiCheckbox.svelte";
    import {validarHorario } from "../lib/utils/requests";

    export let subruta;
    export let data = [];
    export let horario;

    const pagination = false;
    const isPaqueteCompleto = subruta === "paqueteCompleto";
    const isMaquila = subruta === "maquila";
    const estado_solicitado="Solicitada";
    
    let AuditoriaItems = [];
    let vendors = [];
    let vendors1 = [];
    let localData = [];
    let dialogOpen = false;
    let dialogOpenVolver = false;
    let mensaje;
    let buscando = false;
    let referencia = "";
    let rango = "";
    let deshabilitarBtnConfirmar = false;
    const swAuditar = false;
    let estado_sel = estado_solicitado;
    let vendor_sel = "0";
    let PO = "";
    let resp = [];
    resp["mensaje"] = "";
    let globalChecked: boolean = false;
    let texto_columna_fecha;
    let texto_columna_hora;
    let estados = [
        {
            label: "Solicitada",
            value: "Solicitada",
        },
        {
            label: "Programada",
            value: "Programada",
        },
        {
            label: "Lote Fraccionado",
            value: "Lote Fraccionado",
        },
        {
            label: "Entrega Certificada",
            value: "Entrega Certificada",
        },
    ];

    onMount(async() => {
   
        setTimeout(() => {
            document.getElementById("referencia").focus();
        }, 500);
        loadData();

        if(!(await validarRangoHora())){
            return false
        }
        buscar();
    });

    async function validarRangoHora(){
        const resultado = await validarHorario(horario, 'confirmar');
        if (!resultado.valido) {
            mensaje = resultado.mensaje;
            dialogOpenVolver = true;
            return false;
        }
        return true;
    }

    function loadData() {
        referencia = "";
        localData = data.map((x) => {
            return { ...x, checked: false };
        });

        vendors.push({ label: "Todos", value: "0" });

        vendors1 = localData.map((y) => {
            return {
                label: y.name,
                value: y.id,
            };
        });

        vendors = vendors.concat(vendors1);
    }

    async function buscar() {
        buscando = true;
        AuditoriaItems = [];
        const payload = {
            estado: estado_sel,
            vendor: vendor_sel,
            referencia: referencia,
            rango: rango,
            swAuditar: swAuditar,
            po: PO,
            procesoAuditado: subruta
        };


        try {
            const response = await fetch(`/auditoria/buscar_confirmar`, {
                method: "post",
                headers: {
                    "content-type": "application/json",
                },
                body: JSON.stringify(payload),
            });


            if (!response.ok) {
                throw new Error("Error en la respuesta del servidor");
            }

            const facturas = await response.json();

            AuditoriaItems = facturas["data"];
            AuditoriaItems.forEach((x) => {
                const isSolicitada = x.estado === estado_solicitado;
                texto_columna_hora = isSolicitada ? "Hora Sugerida Programada" : "Hora Programada";
                texto_columna_fecha = isSolicitada ? "Fecha Sugerida Programada" : "Fecha Programada";
            });
            AuditoriaItems = AuditoriaItems.map((x) => {
                return { ...x, checked: false };
            });
        } catch (error) {
            mensaje =
                `Ocurrió un error al buscar auditorías: ${error.message}. Por favor, inténtalo de nuevo.`;
            dialogOpen = true;
        } finally {
            buscando = false;
        }
    }

    function cancelar() {
        document.location = `/auditoria/home/${subruta}`;
    }

    function volver() {
        window.location.href = `/auditoria/home/${subruta}`;
    }

    async function confirmar() {

        if(!(await validarRangoHora())){
            return false
        }

        deshabilitarBtnConfirmar = true;
        if (!validar()) {
            dialogOpen = true;
            deshabilitarBtnConfirmar = false;
            return false;
        }
        const payload = AuditoriaItems;

        const response = await fetch("/auditoria/guardar_confirmar", {
            method: "post",
            headers: {
                "content-type": "application/json",
            },
            body: JSON.stringify(payload),
        });
        resp = await response.json();
        
        mensaje = resp["mensaje"];
        dialogOpen = true;
        
        if (response.ok) {
            buscar();
            deshabilitarBtnConfirmar = false;
        }
    }

    function validarFiltros() {
        if (estado_sel !== estado_solicitado && referencia === "" && rango === "") {
            mensaje =
                "Debe seleccionar el filtro de referencia o el filtro de rango de fechas.";
            dialogOpen = true;
        } else {
            buscar();
        }
    }

    function validar() {
        let returno = true;
        AuditoriaItems.forEach((x) => {
            if (x.estado.trim() == estado_solicitado && x.checked) {
                mensaje =
                    "Existen auditorias a guardar con estado Solicitada. Por favor seleccione otro estado";
                returno = false;
            }
        });

        AuditoriaItems.forEach((x) => {
            if (x.auditor.trim() == "" && x.checked) {
                mensaje =
                    "Existen auditorias a guardar sin nombre de auditor. Por favor ingrese el nombre de auditor";
                returno = false;
            }
        });

        let enviar = false;
        AuditoriaItems.forEach((x) => {
            if (x.checked) {
                enviar = true;
            }
        });

        if (!enviar) {
            mensaje = "Debe seleccionar solicitudes";
            return false;
        }

        return returno;
    }


    function excel() {
    
        const payload = {
            estado: estado_sel,
            vendor: vendor_sel,
            referencia: referencia,
            rango: rango,
            swAuditar: swAuditar,
            po: PO,
            procesoAuditado: subruta
        };


        fetch('/auditoria/descargar_auditables', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Error al descargar el archivo Excel.');
                }
                return response.blob();
            })
            .then((blob) => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = 'auditables.xlsx';
                document.body.appendChild(a);
                a.click();
                a.remove();
                window.URL.revokeObjectURL(url);
            })
            .catch((error) => {
                mensaje = 'Ocurrió un error al intentar descargar el archivo Excel. Por favor, inténtelo de nuevo.';
                dialogOpen = true;
            });
    }

    function globalCheckChange() {
        globalChecked = !globalChecked;

        AuditoriaItems = AuditoriaItems.map((item) => {
            return { ...item, checked: globalChecked };
        });
    }
</script>

<section>
    <table class="naui-table w-70">
        <tr>
            <td
                ><NauiSelect
                    bind:value={estado_sel}
                    options={estados}
                    label="Estado"
                /></td
            >
            <td
                ><NauiSelect
                    bind:value={vendor_sel}
                    options={vendors}
                    label="Vendor"
                /></td
            >
            {#if isPaqueteCompleto}
                <td><NauiInput  
                    id="PO" 
                    bind:value={PO} 
                    label="PO"
                 /></td>
            {/if}
            <td
                ><NauiInput
                    id="referencia"
                    bind:value={referencia}
                    label="Referencia"
                /></td
            >
            <td
                ><NauiDateRange
                    label="Buscar registros entre"
                    bind:value={rango}
                /></td
            >
            <td
                ><NauiButton
                    caption="Buscar Solicitudes"
                    mode="outline"
                    color="accent"
                    on:click={validarFiltros}
                /></td
            >
            <td
                ><NauiButton
                    caption="Confirmar Auditoria"
                    mode="outline"
                    color="accent"
                    disabled={deshabilitarBtnConfirmar}
                    on:click={deshabilitarBtnConfirmar === false
                        ? confirmar
                        : () => {}}
                /></td
            >
            <td
                ><NauiButton
                    caption="Descargar Excel"
                    mode="outline"
                    color="accent"
                    on:click={excel}
                /></td
            >
            <td
                ><div>
                    <NauiButton
                        caption="Cancelar"
                        mode="outline"
                        color="accent"
                        on:click={cancelar}
                    />
                </div></td
            >
        </tr>
    </table>

    <table class="naui-table w-100">
        <thead>
            <tr>
                <th width="0%">
                    <NauiCheckbox
                        
                        label=""
                        value={globalChecked}
                        on:click={globalCheckChange}
                    />
                </th>

                <th width="1%"> Sol. </th>
                <th> Vendor </th>
                {#if isPaqueteCompleto}
                    <th>PO</th>
                {/if}
                <th> Referencia </th>
                {#if isMaquila}
                    <th> Tipo de Auditoría </th>
                {/if}
                <th width="1%"> Tipo de Empaque </th>
                <th width="1%"> Q </th>
                <th width="1%"> Cantidad </th>
                <th width="150px"> Estado </th>
                <th width="90px">{texto_columna_fecha} </th>
                <th width="1%">{texto_columna_hora} </th>
                <th width="110px"> Nombre Auditor </th>
                <th width="1%" colspan="3"> Medida Empaque Confección </th>
            </tr>
        </thead>
        <tbody>
            {#each AuditoriaItems as itemE (itemE.id)}
                <AuditoriaItem
                    data={itemE}
                    {estados}
                    bind:checked={itemE.checked}
                    {subruta}
                />
            {:else}
                {#if !buscando}
                    <tr>
                        <td colspan="14">
                            <div><p>No se encontraron registros</p></div>
                        </td>
                    </tr>
                {:else}
                    <tr>
                        <td colspan="14">
                            <div><p>Buscando...</p></div>
                        </td>
                    </tr>
                {/if}
            {/each}
        </tbody>
    </table>

    <Dialog bind:open={dialogOpen}>
        <Title>
            <h3 class="text-c">Confirmar auditoría</h3>
        </Title>
        <Content>
            <div class="max-w-400px text-c mx-auto px-15">
                <p class="large">
                    {mensaje}
                </p>
            </div>
        </Content>
        <Actions>
            <div class="box-r sx-ii px-1 py-ii">
                <NauiButton
                    caption="Aceptar"
                    color="accent"
                    on:click={() => {
                        dialogOpen = false;
                    }}
                />
            </div>
        </Actions>
    </Dialog>

    <Dialog bind:open={dialogOpenVolver} scrimClickAction="" escapeKeyAction="">
        <Title>
            <h3 class="text-c">Confirmar auditoría</h3>
        </Title>
        <Content>
            <div class="max-w-400px text-c mx-auto px-15">
                <p class="large">
                    {mensaje}
                </p>
            </div>
        </Content>
        <Actions>
            <div class="box-r sx-ii px-1 py-ii">
                <NauiButton caption="VOLVER" color="accent" on:click={volver} />
            </div>
        </Actions>
    </Dialog>
</section>


